export const environment = {
  production: true,
  apiBaseUrl: "http://127.0.0.1:4317",
  mvp1TestMode: false,
} as const;
